import * as RouteHelper from "@utils/paths";
import { NotificationType } from "catchment-common/entities/notification";
import { NotificationLineItem } from "catchment-common/interfaces/notification";

/**
 * Maps a notification to the route it should navigate to, or null when the
 * type has no destination. Pure so each branch can be unit-tested without a
 * router.
 */
export const notificationToRoute = (
  notification: NotificationLineItem
): string | null => {
  const projectReports = () =>
    RouteHelper.projectReports(
      notification.projectId,
      notification.contractorPackageId
    );

  switch (notification.type) {
    case NotificationType.PROJECT_REPORT_SUBMITTED:
      return projectReports();
    // Submitted / Accepted / Rejected all open the same read-only report view.
    case NotificationType.MONTHLY_REPORT_SUBMITTED:
    case NotificationType.MONTHLY_REPORT_ACCEPTED:
    case NotificationType.MONTHLY_REPORT_REJECTED:
      // No reportId, no report to open: rows written before the backend
      // started stamping one have nothing to deep-link to. Fall back to the
      // project's reports rather than building the URL anyway — the report
      // route's path builder DROPS an empty segment, so the short URL matches
      // no route and the "*" redirect silently lands the user on Projects.
      if (!notification.reportId) {
        return projectReports();
      }
      return RouteHelper.readOnlyMonthlyReport(
        notification.projectId,
        notification.projectId,
        notification.contractorPackageId,
        notification.reportId
      );
    case NotificationType.SUBCONTRACTOR_ACCEPTED:
      return RouteHelper.packages(
        notification.projectId,
        notification.contractorPackageId
      );
    default:
      return null;
  }
};

/** True when the scroll position is within `threshold` px of the bottom. */
export const isNearBottom = (
  target: { scrollHeight: number; scrollTop: number; clientHeight: number },
  threshold: number
): boolean =>
  target.scrollHeight - target.scrollTop - target.clientHeight < threshold;
